import React from 'react';
import Document from './Document';
import DashboardLayout from '../../../components/Shop/RestaurantLayout/Layout/DashboardLayout';
import messages from '../../../locale/messages';

function action({ store, intl }) {
    const title = intl.formatMessage(messages.document);

    let isRestaurantAuthenticated = store.getState().runtime.isRestaurantAuthenticated;

    if (!isRestaurantAuthenticated) {
        return { redirect: '/restaurant' };
    };

    return {
        title,
        component: (
            <DashboardLayout>
                <Document title={title} />
            </DashboardLayout>
        )
    }
}

export default action;